import { PayloadAction, createSlice } from '@reduxjs/toolkit';

interface BlockMovementState {
	byId: { bloqueKey: string; isMovementDisabled: boolean; isSaved?: boolean }[];
	allIds: string[];
	allowMovement: boolean;
}

interface IBloqueData {
	key: string;
	actividad_key: string;
	cuadro?: any;
	file?: any;
	label: string;
	hasMultipleColumns?: boolean;
	text?: string;
	secondaryText?: any;
	value: string;
	// vertical_position: number;
	// horizontal_position: number;
	// isRespuesta: boolean;
	extraParams?: any;
	alternativas?: any[];
	enlaces?: any[];
	bloques_fill_table?: any[];
	editedRows?: boolean;
}

const initialState: IBloqueData[] = [];

const blockDataStateSlice = createSlice({
	name: 'blockDataState',
	initialState,
	reducers: {
		setBlockData: (state, action) => {
			return action.payload;
		},
		addOrUpdateBlockData: (state, action: PayloadAction<{ keyRegistro: string; data: IBloqueData }>) => {
			const index = state.findIndex((block) => block.key === action.payload.keyRegistro);
			if (index !== -1) {
				// Block exists, update it
				// eslint-disable-next-line no-param-reassign
				state[index] = { ...state[index], ...action.payload.data };
			} else {
				// Block does not exist, add it
				state.push(action.payload.data);
			}
		},
		addBlockData: (state, action) => {
			return [...state, action.payload];
		},
		updateSpecificBlockData: (state, action) => {
			const newArreglo = state?.map((fila) => {
				if (fila.key === action.payload.key) {
					return { ...fila, ...action.payload.data };
				}
				return fila;
			});
			return newArreglo;
		},
		removeSpecificBlockData: (state, action) => {
			const newArreglo = state.filter((fila) => fila.key !== action.payload.key);
			return newArreglo;
		},
		resetBlockData: () => {
			return initialState;
		}
	}
});

export const {
	setBlockData,
	addBlockData,
	addOrUpdateBlockData,
	updateSpecificBlockData,
	removeSpecificBlockData,
	resetBlockData
} = blockDataStateSlice.actions;
export default blockDataStateSlice.reducer;
